import {start_loading,stop_loading} from '../loader/loaderAction'
import { LOAD_PERMISSIONS, TOKENS_UPDATE, USER_DETAILS, USER_LOGOUT, USER_PERMISSIONS, USER_UPDATE } from './authTypes';
import {  toast } from 'react-toastify';
import apiClient from '../../api/apiClient';
import { check_token_expired_logout } from '../user/userAction';
import { authStorage } from '../../api/authStorage';

export const set_update_user = (user,navigate) => {
  navigate('/');
  return { type: USER_UPDATE, payload: user, };
};

export const clear_state_on_logout = () => {
  authStorage.clear();
  return { type: USER_LOGOUT };
};                                     

// admin login function 
export const login_user = async (data, dispatch, navigate) => {
  dispatch(start_loading());
  try {
     const urlPath = "admin/login";

    const res = await apiClient.post(urlPath, JSON.stringify(data), {
      headers: { "Content-Type": "application/json" },
    });

    if (res?.data?.data) {
      toast.success(res?.data?.message,{toastId: "Loginuser"});
      authStorage.save(res.data.data);
      dispatch({ type: USER_PERMISSIONS, payload: res.data.data.permissions });
      dispatch({ type: TOKENS_UPDATE, payload: res.data.data });
      dispatch(set_update_user(res?.data?.data,navigate));
    } else {
      console.log("You have an error");
    }
  } catch (error) {
    toast(error?.response ? error?.response?.data?.error : error?.message);
  } finally {
    dispatch(stop_loading());
  }
};

// admin profile information function 
export const admin_profile = async (dispatch) => {
  try {
    const urlPath = `admin/profile`;
    const response = await apiClient.get(urlPath);
    if(response.data && response.data.data){
      dispatch({ type: LOAD_PERMISSIONS });
      dispatch({ type: USER_PERMISSIONS, payload: response.data.data.permissions });
      dispatch({ type: USER_DETAILS, payload: response.data.data });
    }
    return response.data.data; 
  } catch (error) {
    check_token_expired_logout(error, dispatch);
  }
};

// admin lgout function 
export const user_logout = async (data, dispatch) => {
  try {
    const urlPath = `admin/logout`;
    const res = await apiClient.post(urlPath, data);
    if (res.data && res.data.status) {
      toast.success(res.data.message, { toastId: "updatpwd", autoClose: 1000 });
      return true;
    } else {
      toast.error(res.data.message, { toastId: "updatedpwderr", autoClose: 1000, });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.error, { toastId: "updatedwwwww", autoClose: 1000, });
    check_token_expired_logout(error, dispatch);
  }
};
